<!--
 * @Description: 
 * @Author: lmn
 * @Date: 2022-07-21 17:13:25
 * @LastEditors: lmn
 * @LastEditTime: 2022-07-21 19:04:19
-->
<template>
  <div class="data-loading" :class="{'mask': isMask}">
    <div class="load-layer">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>
<script>
export default {
    props: {
        top: {
            type: Number,
            default() {
                return 0
            }
        },
        bottom: {
            type: Number,
            default() {
                return 0
            }
        },
        left: {
            type: Number,
            default() {
                return 0
            }
        },
        right: {
            type: Number,
            default() {
                return 0
            }
        },
        className: {
            type: String,
            default() {
                return ''
            }
        },
        isMask: {
            type: Boolean,
            default() {
                return false
            }
        }
        // text: {
        //   type: String,
        //   default() {
        //     return "暂无数据";
        //   }
        // }
    }
}
</script>
<style lang="scss">
.data-loading {
    position: relative;
    min-height: 216px;
    height: 100%;
    z-index: 98;
    &.mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background: rgba(3, 33, 73, 0.8);
    }
    .load-layer {
        position: absolute;
        top: calc(50% + 5px);
        left: 50%;
        text-align: center;
        transform: translate(-50%, -50%);
        height: 20px;
        width: 40px;
        span {
            display: inline-block;
            background: rgb(93, 174, 255);
            width: 6px;
            height: 100%;
            border-radius: 4px;
            margin: 0 2px;
            animation: loadingData 1.04s ease infinite;
            &:nth-child(2) {
                animation-delay: 0.13s;
            }
            &:nth-child(4) {
                animation-delay: 0.39s;
            }
        }
    }
}

@keyframes loadingData {
    0%,
    to {
        height: 10px;
    }
    50% {
        height: 27px;
        margin-top: -20px;
        opacity: 0.7;
    }
}
</style>